import { API_ENDPOINTS } from "../constants/apiConfig";
import { makeRequest } from "../middleware/axiosMiddleware";

export const userService = {
  searchUser,
  getAllAdmins,
  getUserRoleList,
  updateUserRole,
  saveUserDOB,
  saveUserFacilityId,
  getRegisterdUserCount,
  getDeactivatedUserCount,
  getInterastedUserCountForOffer,
  getInterastedUserForOffer,
  resetFaildAttemptCounter,
  resetLoginAttemptCounter,
  getRegisteredUsers,
  updateInterestedUserStatus,
  getOfferActivityLogs,
};

async function searchUser(callingCode: any, mobile: any) {
  const apiPath =
    API_ENDPOINTS.GET_SEARCH_USER +
    "?callingCode=" +
    callingCode +
    "&mobile=" +
    mobile;
  const options = {
    path: apiPath,
    method: "GET",
    bodyObj: {},
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function getAllAdmins(skip: any, take: any) {
  const apiPath =
    API_ENDPOINTS.GET_ALL_ADMIN + "?skip=" + skip + "&take=" + take;
  const options = {
    path: apiPath,
    method: "GET",
    bodyObj: {},
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function updateUserRole(userId: any, roleId: any) {
  const apiPath = API_ENDPOINTS.UPDATE_USER_ROLE;
  const options = {
    path: apiPath,
    method: "PUT",
    bodyObj: {
      userId: userId,
      roleId: roleId,
    },
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function getUserRoleList() {
  const apiPath = API_ENDPOINTS.GET_USER_ROLE_LIST;
  const options = {
    path: apiPath,
    method: "GET",
    bodyObj: {},
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function saveUserDOB(dateOfBirth: any) {
  const apiPath = API_ENDPOINTS.SAVE_USER_DOB;
  const options = {
    path: apiPath,
    method: "PUT",
    bodyObj: {
      dateOfBirth: dateOfBirth,
    },
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function saveUserFacilityId(facilityId: any) {
  const apiPath = API_ENDPOINTS.SAVE_PREFERRED_FACILITY;
  const options = {
    path: apiPath,
    method: "PUT",
    bodyObj: {
      facilityId: facilityId,
    },
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function getRegisterdUserCount() {
  const apiPath = API_ENDPOINTS.GET_REGISTERED_USER_COUNT;
  const options = {
    path: apiPath,
    method: "GET",
    bodyObj: {},
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function getDeactivatedUserCount() {
  const apiPath = API_ENDPOINTS.GET_DEACTIVATED_USER_COUNT;
  const options = {
    path: apiPath,
    method: "GET",
    bodyObj: {},
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function getInterastedUserCountForOffer() {
  const apiPath = API_ENDPOINTS.GET_INTERASTED_USER_COUNT_FOR_OFFERS;
  const options = {
    path: apiPath,
    method: "GET",
    bodyObj: {},
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function getInterastedUserForOffer(offerId: any, skip: any, take: any) {
  const apiPath =
    API_ENDPOINTS.GET_INTERASTED_USERS_FOR_OFFERS +
    offerId +
    "&skip=" +
    skip +
    "&take=" +
    take;
  const options = {
    path: apiPath,
    method: "GET",
    bodyObj: {},
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function resetFaildAttemptCounter(userId: any) {
  const apiPath = API_ENDPOINTS.RESET_FAILD_ATTEMPT_COUNTER;
  const options = {
    path: apiPath,
    method: "POST",
    bodyObj: {
      userId: userId,
    },
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function resetLoginAttemptCounter(userId: any) {
  const apiPath = API_ENDPOINTS.RESET_LOGIN_ATTEMPT_COUNTER;
  const options = {
    path: apiPath,
    method: "POST",
    bodyObj: {
      userId: userId,
    },
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function getRegisteredUsers(skip: any, take: any) {
  const apiPath =
    API_ENDPOINTS.GET_REGISTERED_USERS_LIST + "?skip=" + skip + "&take=" + take;
  const options = {
    path: apiPath,
    method: "GET",
    bodyObj: {},
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function updateInterestedUserStatus(
  offerInterestId: number,
  status: string,
  comment: string
) {
  const apiPath = API_ENDPOINTS.UPDATE_INTERESTED_USERS_STATUS;
  const options = {
    path: apiPath,
    method: "PUT",
    bodyObj: {
      offerInterestId: offerInterestId,
      status: status,
      comment: comment,
    },
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}

async function getOfferActivityLogs(offerInterestId: number) {
  const apiPath = API_ENDPOINTS.GET_OFFER_ACTIVITY_LOGS + offerInterestId;
  const options = {
    path: apiPath,
    method: "GET",
    bodyObj: {},
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequest(options);
}
